const JobStatusIcon = {
  REFRESH: 1,
  WARNING: 2,
  CHECK: 3,
};

export default JobStatusIcon;
